<template lang="pug">
.modal-card(style="width: 100%")  
  header.modal-card-head
    p.modal-card-title Verträge

  section.modal-card-body
    div
      .card.margin-top
        .top
          .left
          .right
        .main
          b-table(:data="booking.parentContract.contracts"
                  default-sort-direction="asc"
                  default-sort="id")
            b-table-column(field='id' label='Vertrags-ID.' width='40' sortable centered v-slot="props")
              | {{ props.row.id }}
            b-table-column(field='createdAt' label='Erstellt am' sortable centered v-slot="props")
              | {{ formatDate(props.row.createdAt) }}
            b-table-column(field='signedContract' label='Unterschrieben' sortable centered v-slot="props")
              b-icon(v-if="booking.signedContractId === props.row.id" icon="check-all" type="is-success")
              b-button(type="is-flat" v-if="booking.signedContractId !== props.row.id" icon-left="check-all" @click="updateSignedContract(props.row.id)") Aktualisieren
            b-table-column(field='downPaymentDueDate' label='A Frist' sortable numeric v-slot="props")
              | {{ props.row.downPaymentDueDate ? formatDate(props.row.downPaymentDueDate) : '-' }}
            b-table-column(field='totalDownPayment' label='Anzahlung' sortable numeric v-slot="props")
              | {{props.row.totalDownPayment / 100 | toCurrency}}
            b-table-column(field='finalPaymentDueDate' label='R Frist' sortable numeric v-slot="props")
              | {{ formatDate(props.row.finalPaymentDueDate) }}
            b-table-column(field='totalFinalPayment' label='Restzahlung' sortable numeric v-slot="props")
              | {{props.row.totalFinalPayment / 100 | toCurrency}}
            b-table-column(field='totalRentPrice' label='Mietpreis' sortable numeric v-slot="props")
              | {{props.row.totalRentPrice / 100 | toCurrency}}
            b-table-column(field='totalItemPrice' label='Extraspreis' sortable numeric v-slot="props")
              | {{props.row.totalItemPrice / 100 | toCurrency}}
            b-table-column(field='totalPrice' label='Gesamt' sortable numeric v-slot="props")
              | {{props.row.totalPrice / 100 | toCurrency}}
            b-table-column(v-slot="props")
              .spacer.md
            b-table-column(field='totalCommission' label='Prov. netto' sortable numeric v-slot="props")
              | {{props.row.totalCommission / 100 | toCurrency}}
            b-table-column(field='totalCommissionTax' label='Prov. MwSt' sortable numeric v-slot="props")
              | {{props.row.totalCommissionTax / 100 | toCurrency}}
            b-table-column(field='totalSettlement' label='Eigentümer' sortable numeric v-slot="props")
              | {{props.row.totalSettlement / 100 | toCurrency}}
    
  footer.modal-card-foot
    button.button.is-light(@click="$emit('close')") Abbrechen
</template>

<script>
import { DateTime } from "luxon"

export default {
  props: {
    bookingId: {
      type: Number
    },
  },
  data() {
    return {
      booking: {
        parentContract: {
          contracts: []
        }
      }
    };
  },
  async mounted() {
    this.booking = await this.$store.dispatch("rentObjectBookings/findOne", {id: this.bookingId});
  },
  methods: {
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.toLocaleString({
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    async updateSignedContract(contractId) {
      await this.$store.dispatch("rentObjectBookings/updateSignedContract", {id: this.bookingId, contractId});
      this.booking = await this.$store.dispatch("rentObjectBookings/findOne", {id: this.bookingId});
    }
  }
}
</script>

<style lang="scss" scoped>
</style>